__turbopack_context__.v({
  "box": "card-form-alert-module__PCLmIq__box",
});
